import React, { useContext, useEffect, useState } from 'react'
import { cards, categories } from '../data/cardInfo'
import _, { update } from 'lodash'
import classNames from 'classnames'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { Button, Wrapper } from './StartPage'
import { quizes, generalInfo } from '../data/quizSettings'
import QuizQuestion from './QuizQuestion'
import {QuizContext} from '../context/QuizContext'
import Star from './Star'

const Quiz = () => {

  const {difficulty} = useParams()
  const {totalQuestions, questionTypes, questionCategories, minQuestionsOfType} = quizes[difficulty]
  
  //const questions = _.take(_.shuffle(cards),totalQuestions)
  const [questions, setQuestions] = useState()
  const [answers, setAnswers] = useState()
  const [questionType, setQuestionType] = useState()
  const {setQuestionInfo, questionNumber, setQuestionNumber, result, setResult} = useContext(QuizContext)
  const [score, setScore] = useState(0)
  const history = useHistory()

  const checkAnswer = (correct) => {
    const newScore = correct ? (score+1) : (score)
    setScore(newScore)
    let newResult = [...result]
    //newResult[questionNumber].correct = correct
    // setResult(prevResult => {
    //   return prevResult.map((v,i) => (i === questionNumber) ? correct : v)
    // })
    if (questionNumber< totalQuestions-1) {
      setQuestionNumber(questionNumber+1)
    } else {
      history.push('/result?score=' + newScore)
    }
  }

  const generateAnswers = (question) => {
    const cardSet = questionCategories ? (
      cards.filter(card => questionCategories.includes(card.categoryId))
    ) : (
      cards
    )
    let tempAnswers
    if (question.type === 'titleToDescription' || question.type === 'descriptionToTitle') {
      const newCardSet =  cardSet.filter(card => card.categoryId === question.card.categoryId)
      tempAnswers = _.take(_.shuffle(newCardSet.filter(card => card.title !== question.card.title)),2)

    } else {
      tempAnswers = _.take(_.shuffle(cardSet.filter(card => card.title !== question.card.title)),2)
    }
    tempAnswers.push(question.card)
    return _.shuffle(tempAnswers)
  }

  const generateQuestions = () => {
    const cardSet = questionCategories ? (
      cards.filter(card => questionCategories.includes(card.categoryId))
    ) : (
      cards
    )
    const questionCards = _.take(_.shuffle(cardSet),totalQuestions)
    let tempTypes = []
    if (minQuestionsOfType) {
      const predefinedTypes = minQuestionsOfType.map(item => {
        return Array(item.count).fill(item.type)
      }).flat()
      console.log(predefinedTypes.length)
      const randomTypes = _.sampleSize(questionTypes, totalQuestions-predefinedTypes.length)
      tempTypes = _.shuffle([...predefinedTypes,...randomTypes])
    } else {
      tempTypes = [...Array(totalQuestions)].map(unused => _.sample(questionTypes))
      console.log(tempTypes, questionTypes, totalQuestions)
    }
    const questionData = _.zipWith(questionCards, tempTypes, (card,type) => ({card:card, type:type}))
    console.log(questionData)
    return questionData
  }

  useEffect(() => {
    //const tempQuestions = _.take(_.shuffle(cards),totalQuestions)
    const tempQuestions = generateQuestions()
    setAnswers(generateAnswers(tempQuestions[questionNumber]))
    setQuestions(tempQuestions)
    //setQuestionType(_.sample(questionTypes))
    setQuestionType(tempQuestions[questionNumber].type)
    setQuestionInfo(tempQuestions[questionNumber].card)
    setResult(Array(totalQuestions).fill(null))
  }, [])
  
  useEffect(() => {
    if (questions) {
      setAnswers(generateAnswers(questions[questionNumber]))
      //setQuestionType(_.sample(questionTypes))
      setQuestionType(questions[questionNumber].type)
      setQuestionInfo(questions[questionNumber].card)
    }
  }, [questionNumber])

  return (
    <Wrapper className='quiz'>
    <h4 className='header'>{generalInfo.typeDescriptions[questionType]}</h4>
    <div className='flex-row'>
      <div>Fråga {questionNumber+1}/{totalQuestions}</div>
      <div className='flex-row'>
        {result.map((correct,i) => {
          return <Star key={i} correct={correct} />
        })}
      </div>
      {/* <div>Poäng: {score}/{questionNumber}</div> */}
    </div>
    {questions && 
      <QuizQuestion question={questions[questionNumber].card} questionType={questionType} answers={answers} checkAnswer={checkAnswer} />
    }
    </Wrapper>
  )
}

export default Quiz
